export const ja = {
  heroData: {
    title: "ご予約の流れ",
    subtitle: "WEBから簡単に予約相談ができます。専任スタッフが、ご希望に合わせた最適なプランをご提案します。",
    image: "https://readdy.ai/api/search-image?query=Modern%20office%20desk%20with%20laptop%20showing%20travel%20booking%20website%2C%20warm%20ambient%20lighting%2C%20elegant%20workspace%20with%20notebook%20and%20coffee%2C%20professional%20consultation%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=bookhero01&orientation=landscape",
  },
  stepsData: {
    label: "STEP",
    title: "ご予約から搭乗まで",
    steps: [
      { num: "01", title: "WEBで相談フォーム送信", desc: "希望日・時間帯・人数・目的を入力して送信。24時間受付可能です。", details: ["翌営業日以内にご連絡", "複数プランの比較OK", "日程調整も承ります"] },
      { num: "02", title: "専任スタッフからご提案", desc: "ご入力内容をもとに、最適なプランと空き状況をご提案。ご不明点もこの段階で解消できます。", details: ["プラン比較表を作成", "オプションのご案内", "お支払い方法の確認"] },
      { num: "03", title: "ご予約の確定", desc: "ご希望のプランが決まれば、ご予約を確定。お支払いの案内をお送りします。", details: ["予約確認書の発行", "お支払い案内", "アクセス情報の送付"] },
      { num: "04", title: "事前案内の送付", desc: "搭乗前に、服装・持ち物・当日の流れ・アクセスをメールでご案内。", details: ["服装ガイド", "持ち物チェックリスト", "ヘリポートアクセス案内"] },
      { num: "05", title: "当日の搭乗", desc: "ヘリポートへお越しいただき、受付後に搭乗。特別な体験が始まります。", details: ["受付・安全説明", "パイロット挨拶", "記念撮影（オプション）"] },
    ],
  },
  finalCTA: {
    title: "まずは、お気軽に\nご相談ください",
    subtitle: "専任スタッフが、ご希望を丁寧にお伺いします",
    ctas: [
      { label: "予約について問い合わせる", href: "/contact", type: "primary" },
      { label: "料金・プランを見る", href: "/pricing", type: "secondary" },
    ],
  },
};

export const en = {
  heroData: {
    title: "How to Book",
    subtitle: "Booking is easy through our online inquiry form. Our dedicated staff will suggest the best plan for your needs.",
    image: "https://readdy.ai/api/search-image?query=Modern%20office%20desk%20with%20laptop%20showing%20travel%20booking%20website%2C%20warm%20ambient%20lighting%2C%20elegant%20workspace%20with%20notebook%20and%20coffee%2C%20professional%20consultation%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=bookhero01&orientation=landscape",
  },
  stepsData: {
    label: "STEP",
    title: "From Booking to Boarding",
    steps: [
      { num: "01", title: "Submit an Inquiry Online", desc: "Enter your preferred date, time, and number of guests, then submit. Available 24 hours a day.", details: ["Response within the next business day", "Compare multiple plans", "Flexible date adjustments"] },
      { num: "02", title: "Receive a Proposal from Our Staff", desc: "Based on your inquiry, we will suggest the best plan and check availability. Any questions can be resolved at this stage.", details: ["Personalized plan comparison", "Option guidance", "Payment method confirmation"] },
      { num: "03", title: "Confirm Your Booking", desc: "Once you have chosen your plan, we will confirm your reservation and send payment instructions.", details: ["Booking confirmation issued", "Payment instructions sent", "Access information provided"] },
      { num: "04", title: "Pre-Departure Guide", desc: "Before your flight, we will send detailed guidance on attire, what to bring, the day-of schedule, and access information.", details: ["Attire guide", "Packing checklist", "Helipad access guide"] },
      { num: "05", title: "Board on the Day", desc: "Arrive at the helipad, check in, and board. Your special experience begins.", details: ["Check-in & safety briefing", "Pilot introduction", "Commemorative photo (optional)"] },
    ],
  },
  finalCTA: {
    title: "Feel free to reach\nout anytime",
    subtitle: "Our dedicated staff will carefully listen to your needs",
    ctas: [
      { label: "Inquire About Booking", href: "/contact", type: "primary" },
      { label: "View Pricing & Plans", href: "/pricing", type: "secondary" },
    ],
  },
};
